import { TITLE_POSTFIX } from 'constants/seo'

export const formatSeoTitle = (text: string) => `${text} ${TITLE_POSTFIX}`
